// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2sMci","alert":"SettungsInbox_alert__CJ0Ji"};